export function NumbersSection() {
  const stats = [
    {
      number: '10',
      label: 'Ekip Üyesi',
    },
    {
      number: '2M',
      label: 'API İsteği / Gün',
    },
    {
      number: '$3M',
      label: 'Toplam Fonlama',
    },
  ];

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @media (max-width: 768px) {
            .mobile-numbers-section {
              padding: 40px 20px !important;
            }
            .mobile-numbers-container {
              padding: 40px 20px !important;
            }
            .mobile-numbers-grid {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 16px !important;
              height: auto !important;
            }
            .mobile-numbers-card {
              padding: 24px 16px !important;
            }
            .mobile-numbers-number {
              font-size: 36px !important;
            }
            .mobile-numbers-label {
              font-size: 11px !important;
            }
          }
        `,
        }}
      />
      <div className="w-full py-[40px] bg-slate-950 flex justify-center items-center mobile-numbers-section">
        <div className="w-full max-w-[1200px] px-[60px] py-10 bg-slate-950 border-t border-white border-opacity-[0.06] flex flex-col justify-start items-start gap-12 mobile-numbers-container">
          <div className="w-full flex justify-start items-center gap-3">
            <div
              className="size-2.5 rounded-[3px]"
              style={{ background: '#76BCE8' }}
            />
            <div className="inline-flex flex-col justify-start items-start">
              <div
                className="justify-center text-xs font-semibold font-['Inter'] uppercase tracking-widest"
                style={{ color: 'rgba(255, 255, 255, 0.5)' }}
              >
                Rakamlarla CommerceMinder
              </div>
            </div>
          </div>

          <div className="w-full h-40 grid grid-cols-3 gap-10 mobile-numbers-grid">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="self-stretch px-5 py-10 bg-neutral-900 rounded-2xl outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex flex-col justify-start items-start gap-2 mobile-numbers-card transition-all duration-300 cursor-pointer hover:border-[rgba(118,188,232,0.20)] hover:bg-[#111] hover:shadow-[0_20px_60px_0_rgba(0,0,0,0.40)]"
                style={{
                  boxShadow: '0px 4px 40px 0px rgba(0, 150, 196, 0.25)',
                }}
              >
                <div className="self-stretch flex flex-col justify-start items-center">
                  <div
                    className="text-center justify-center text-5xl font-bold font-['Inter'] mobile-numbers-number"
                    style={{ color: '#9DD0F0' }}
                  >
                    {stat.number}
                  </div>
                </div>
                <div className="self-stretch flex flex-col justify-start items-center">
                  <div
                    className="text-center justify-center text-xs font-medium font-['Inter'] mobile-numbers-label"
                    style={{ color: 'rgba(255, 255, 255, 0.25)' }}
                  >
                    {stat.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
